import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { RadioGroup, Radio, RadioError } from 'components/fields'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import validate from './SelectOrganization.validate'

@form({
  form: 'selectOrganizationForm',
  validate
})
class SelectOrganization extends Component {
  static propTypes = {
    organizations: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired
  }

  static defaultProps = {
    organizations: []
  }

  render() {
    const { organizations, handleSubmit, onSubmit } = this.props

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <RadioGroup>
          {organizations.map((item, index) => (
            <Radio
              key={index}
              label={item.name}
              value={String(item.id)}
              name="organizationId"
            />
          ))}
        </RadioGroup>
        <RadioError name="selectOrganization" />
        <div className="row">
          <div className="col-xs-12 text--right">
            <Button type="submit">Select</Button>
          </div>
        </div>
      </form>
    )
  }
}

export default SelectOrganization
